import { render, staticRenderFns } from "./ContractsSM.vue?vue&type=template&id=465b23cc&"
import script from "./ContractsSM.vue?vue&type=script&lang=js&"
export * from "./ContractsSM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports